module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    on: {
      "close": _vm.onClose
    },
    model: {
      value: (_vm.showShare),
      callback: function($$v) {
        _vm.showShare = $$v
      },
      expression: "showShare"
    }
  }, [_c('div', {
    staticClass: "footer",
    staticStyle: {
      "z-index": "10000"
    }
  }, [_c('div', {
    staticClass: "footer-tile"
  }, [_vm._v(_vm._s(_vm.reward > 0 ? '分享后预计最高可赚取￥' + _vm.reward : '分享给好友'))]), _vm._v(" "), _c('div', {
    staticClass: "footer-btn flex-start"
  }, [_c('div', {
    staticClass: "footer-one-btn",
    on: {
      "click": _vm.goPoster
    }
  }, [_c('img', {
    staticClass: "footer-one-img",
    attrs: {
      "src": "https://static.dierqudao.com/images/icon-share-qrcode.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "footer-one-text gray"
  }, [_vm._v("海报")])]), _vm._v(" "), _c('div', {
    staticClass: "footer-one-btn",
    on: {
      "click": _vm.onWeixinTimeLine
    }
  }, [_c('img', {
    staticClass: "footer-one-img",
    attrs: {
      "src": "https://static.dierqudao.com/images/icon-pengyouquan.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "footer-one-text gray"
  }, [_vm._v("朋友圈")])]), _vm._v(" "), _c('div', {
    staticClass: "footer-one-btn",
    on: {
      "click": _vm.onWeixinFriend
    }
  }, [_c('img', {
    staticClass: "footer-one-img",
    attrs: {
      "src": "https://static.dierqudao.com/images/icon-share-weixin.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "footer-one-text gray"
  }, [_vm._v("微信好友")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.share.get_url),
      expression: "share.get_url",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopyUrl),
      expression: "onCopyUrl",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: (_vm.onError),
      expression: "onError",
      arg: "error"
    }],
    staticClass: "footer-one-btn"
  }, [_c('img', {
    staticClass: "footer-one-img",
    attrs: {
      "src": "https://static.dierqudao.com/images/icon-share-copy.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "footer-one-text gray"
  }, [_vm._v("复制链接")])])]), _vm._v(" "), _c('div', {
    staticClass: "cancle",
    on: {
      "click": _vm.onClose
    }
  }, [_vm._v("取消")])])]), _vm._v(" "), (_vm.showWxShare) ? _c('div', {
    staticClass: "shareShow",
    on: {
      "click": _vm.cancleShare
    }
  }, [_vm._m(0)]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("点击分享给好友")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-718cab91","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShareDialog.vue
// module id = 2476
// module chunks = 0